/**
 * Encabezado de la seccion de la aseguradora. El texto es de Mike (9-oct):
 * "A focus is to make the insurance company feel comfortable".
 */
export default function InsuranceAdminNotice() {
  return (
    <div className="space-y-3" data-testid="insurance-admin-notice">
      <div>
        <h1 className="text-2xl md:text-3xl font-semibold tracking-tight">Insurance Admin Section</h1>
        <p className="text-slate-500 mt-1 text-sm">
          This section is dedicated to the insurance partner, the Broker of Record and the SelleSend executive team.
        </p>
      </div>
      <div className="rounded-lg border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900/60 px-4 py-3 text-sm">
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Notice</p>
        <p className="mt-1 text-slate-700 dark:text-slate-300">
          This section is for the confidential use and maintenance of the Management Services team,
          licensed insurance brokers and our insurance partner, and shall be maintained as such.
        </p>
      </div>
    </div>
  );
}
